import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormControl, NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { map, take, startWith, takeUntil } from 'rxjs/operators';
import { locale as English } from '../i18n/en';
import { locale as French } from '../i18n/fr';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { fuseAnimations } from '@fuse/animations';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { User } from 'app/main/user/user.model';
import { UserFacade } from 'app/main/user/user.facade';
import { ActiviteDialogComponent } from 'app/main/activite/activite-dialog/activite-dialog.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FuseConfirmDialogComponent } from '@fuse/components/confirm-dialog/confirm-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { GroupeFacade } from 'app/main/groupe/groupe.facade';
import { Groupe } from 'app/main/groupe/groupe.model';
import { AbstractNotificationService } from 'app/shared/service/notification.service';
import { Notif } from '../notif.model';

@Component({
  selector: 'app-notification-add-form',
  templateUrl: './notification-add-form.component.html',
  styleUrls: ['./notification-add-form.component.scss'],
    animations: fuseAnimations,
    encapsulation: ViewEncapsulation.None
})
export class NotificationAddFormComponent implements OnInit, OnDestroy {
    isDirty = false;
    groupe: Groupe;
    notif: Notif;
    users$: Observable<User[]>;
    users: User[];
    inputUserControl = new FormControl();
    filteredUsers$: Observable<User[]>;
    groupes$: Observable<Groupe[]>;
    user: User;
    groupes: Groupe[];
    filteredGroupes$: Observable<Groupe[]>;
    user$: Observable<User>;
    currentUser:User;
    destroyed$ = new Subject<boolean>();
    inputGroupeControl: FormControl;
  

    @ViewChild('notifForm') form: NgForm;


    constructor(
        public dialogRef: MatDialogRef<NotificationAddFormComponent>,
        private _messageService: MessageService,
        private _groupeFacade: GroupeFacade,
        private _userFacade: UserFacade,
        private _abstractNotificationService: AbstractNotificationService,
        private _translateService: TranslateService,
        private dialog: MatDialog,
        private _route: ActivatedRoute,
        private _translateLoaderService: FuseTranslationLoaderService) {
        this._translateLoaderService.loadTranslations(English, French);
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.inputUserControl = this.form.controls['inputUser'] as FormControl;
            this.inputGroupeControl = this.form.controls['inputGroupe'] as FormControl;
            this.users$.subscribe(users => {
                if (users) {
                    this.users = users;
                    this.filteredUsers$ = this.inputUserControl.valueChanges.pipe(
                        startWith(''),
                        map(value => typeof value === 'string' || value === null ? value : value?.name),
                        map(name => this._filterUser(name))
                    );
                }
            });
            this.groupes$.subscribe(groupes => {
              if ( groupes){
                
                  this.groupes = groupes;
                  this.filteredGroupes$ = this.inputGroupeControl
                  .valueChanges.pipe(
                      startWith(''),
                      map(value => typeof value === 'string' || value === null ? value : value?.name),
                      map(name => this._filterGroupe(name))
                  );
                  
              }
            
          });
          /*
            if (!this.addingNew && this.groupe && (!this.groupe.users || this.groupe.users.length == 0)) {
                this._translateService.get(['GROUPE']).pipe(take(1))
                    .subscribe(msgs => {
                        this._messageService.add({ sticky: true, severity: 'warn', summary: msgs.GROUPE.MSG_USERS });
                    });

            }
            */
            this.form.valueChanges.pipe(takeUntil(this.destroyed$)).subscribe(values => this.isDirty = true);


        }, 0);
    }
    closeDialog() { 
        this.dialogRef.close();
      }
    private _filterGroupe(name: string): Groupe[] {
      if (name) {
        console.log("eeeeeeeee"+name)
      let filterValue = name.toLowerCase();
      return this.groupes.filter(groupe => this.notif.groupes
          .findIndex(g => g.id == groupe.id) === -1 && groupe.name.toLowerCase().includes(filterValue));
  
      
     }
      else {
          return this.groupes.filter(groupe => this.notif.groupes
              .findIndex(g =>  groupe.id == g.id ) === -1);
      }
     
  }
    private _filterUser(name: string): User[] {
        if (name) {
            let filterValue = name.toLowerCase();
            return this.users.filter(user => this.notif.users
                .findIndex(e => e.id == user.id) === -1 && (user.name).toLowerCase()
                    .includes(filterValue));
        } else {
            return this.users.filter(user => this.notif.users
                .findIndex(e => user.id == e.id) === -1);
        }
    }
    deleteGroupe(index: number) {
      let confirmDialogRef = this.dialog.open(FuseConfirmDialogComponent, {
          disableClose: false,
          data: {
              confirmMessage: 'App.MSG-DELETE',
              title: 'App.CONFIRM',
              confirmButtonText: 'App.CONFIRM',
              cancelButtonText: 'App.CANCEL'
          }
      });

      confirmDialogRef.afterClosed().subscribe(result => {
          if (result) {
              this.notif.groupes.splice(index, 1);
              this.inputGroupeControl.reset();
          }
          confirmDialogRef = null;
      });

  }
  onGroupeSelect(event: MatAutocompleteSelectedEvent) {
    if (typeof event.option.value == 'object') {
        this.groupe = event.option.value;
        if (this.groupe && this.groupe == this.inputGroupeControl.value) {

            this.notif.groupes.push(this.groupe)
            this.groupe = null;
            this.inputGroupeControl.reset();
      
          
        }
  
    }
}






verifGroupe(): boolean {
  return this.groupe && typeof this.inputGroupeControl.value === 'object';
}



displayGroupe(groupe: Groupe): string {
  return groupe && groupe.name ? groupe.name : '';
}
    ngOnInit(): void {
        this.user$=this._userFacade.getCurrentUser();
        this.user$.subscribe(user => {
                   
            if( user){
            console.log(user.username);
            this.currentUser=user;
            }
   
            });
        this.notif = new Notif();
        let id = this._route.snapshot.params['id'];
        this.users$ = this._userFacade.getEnabledUsers();

        this._groupeFacade.loadAll();
        this.groupes$ = this._groupeFacade.all$;
        
       
           
       

    
    }
    onSubmit(form: NgForm) {
        const usersList= [...this.notif.users, ...this.notif.groupes
            .map(group => group.users) // Liste des utilisateurs pour chaque groupe
            .reduce((acc, users) => acc.concat(users), []) // Aplatir les tableaux de User[]
            ];
            // Supprimer les doublons si nécessaire
const uniqueUsers = usersList.filter(
    (user, index, self) =>
      self.findIndex(u => u.id === user.id) === index // Vérifie l'unicité en comparant les ID
  );
  if(uniqueUsers.length >0)
    {
        
        if (form.valid) {
     
      this._abstractNotificationService.sendNotification({
        className: 'Chat',
        criticity: true,
        date: new Date().toISOString(),
        name:  this.currentUser.username+ ' : '+this.notif.name,
        description: this.notif.description,
        users: uniqueUsers,
        
    });
    this.closeDialog();
}
}else{
    const confirmDialogRef = this.dialog.open(FuseConfirmDialogComponent, {
        disableClose: false,
        data: {
            confirmMessage: 'NOTIF.REQUIRED_USER',
            title: 'NOTIF.REQUIRED',
            confirmButtonText: 'App.CONFIRM',
            cancelButtonText: 'App.CANCEL'
        }
    });

    confirmDialogRef.afterClosed().subscribe(result => {
        

    });

}

}
    

    ngOnDestroy() {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
    deleteUser(index: number) {
        let confirmDialogRef = this.dialog.open(FuseConfirmDialogComponent, {
            disableClose: false,
            data: {
                confirmMessage: 'App.MSG-DELETE',
                title: 'App.CONFIRM',
                confirmButtonText: 'App.CONFIRM',
                cancelButtonText: 'App.CANCEL'
            }
        });

        confirmDialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.notif.users.splice(index, 1);
                this.inputUserControl.reset();
            }
            confirmDialogRef = null;
        });

    }
    verifUser(): boolean {
        return this.user && typeof this.inputUserControl.value === 'object';
    }

    onUserSelect(event: MatAutocompleteSelectedEvent) {
        if (typeof event.option.value == 'object') {
            this.user = event.option.value;
            if (this.user && this.user == this.inputUserControl.value) {

                this.notif.users.push(this.user)
                this.user = null;
                this.inputUserControl.reset();
    
                // }
            }
        }
    }

    displayUser(user: User): string {
        return user && user.username ? user.username : '';
    }
}



